import React from 'react';
import { UserSearchContextProvider } from './UserSearchContext';
import { BranchesContextProvider } from './BranchesContext';
import { BookingTimerProvider } from './BookingTimerContext';

export * from './BranchesContext';

export const AppContext = ({ children }: { children: React.ReactNode }) => (
  <BookingTimerProvider>
    <BranchesContextProvider>
      <UserSearchContextProvider>{children}</UserSearchContextProvider>
    </BranchesContextProvider>
  </BookingTimerProvider>
);
